export { default } from './RemoveCookieElement';
